<!-- GENERICS MODAL -->
<div class="modal-header bg-blu text-white"
   [ngClass]="{'bg-yellow': message.type==='warning','bg-red': message.type==='error'}">
   <h5 class="modal-title"> {{message.title}}</h5>
   <button type="button" class="text-white close" aria-label="Close" (click)="activeModal.close(resultTypes.Cross)">
      <span aria-hidden="true">&times;</span>
   </button>
</div>
<div class="modal-body">
   <p [innerHTML]="message.content"></p>
</div>
<div class="modal-footer">
   <button type="button" class="btn bg-blu txt-white" (click)="activeModal.close(resultTypes.Confirm)"
      *ngIf="message.type==='confirm'">Conferma</button>
   <button type="button" class="btn btn-bg-outline" (click)="activeModal.close(resultTypes.Close)">Chiudi</button>
</div>